import { render } from "./FeedbackTab.vue?vue&type=template&id=5d4e9d6e&scoped=true"
import script from "./FeedbackTab.vue?vue&type=script&lang=js"
export * from "./FeedbackTab.vue?vue&type=script&lang=js"

import "./FeedbackTab.vue?vue&type=style&index=0&id=5d4e9d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4e9d6e"]])

export default __exports__